module.exports = __webpack_public_path__ + "img/christopher-robin.252b7f34.jpg";